import {Component, Inject, OnInit} from '@angular/core';
import { MatDialogRef } from "@angular/material/dialog";
import {
  MAT_DIALOG_DATA
} from "@angular/material/dialog";
import {TranslateService} from "../../../services/translate.service";

// https://www.techiediaries.com/angular-material-dialogs/
@Component({
  selector: 'dialog-b',
  templateUrl: './dialog-body.component.html',
  styleUrls: ['./dialog-body.component.css']
})
export class DialogBodyComponent implements OnInit {

  constructor(private translate: TranslateService, public dialogRef: MatDialogRef<DialogBodyComponent>, @Inject(MAT_DIALOG_DATA) public data: any) { }

  onlyMessage = true;

  ngOnInit() {
    if ('string' === typeof this.data) {
      this.onlyMessage = true;
    } else {
      this.onlyMessage = false;
      for (let iData in this.data) {
        let translated = '';
        if (null != this.translate.data[this.data[iData]]) {
          translated = this.translate.data[this.data[iData]];
        }
        this.data[iData] = translated;
      }
    }
  }

  close() {
    this.dialogRef.close("Thanks for using me!");
  }

}
